export async function requestStorageItemsForScope (query, { checkScope, loadItems, onScopeResolved }) {
  const scope = await checkScope(query)

  if (scope?.warehouseRequired) {
    return { warehouseRequired: true }
  }

  if (onScopeResolved) {
    onScopeResolved(scope)
  }

  return {
    warehouseRequired: false,
    data: await loadItems(query)
  }
}
